import React from 'react';
import { designVsLiveRows, type AnalysisFlag } from '../../data/clearDocs';
const FLAG: Record<AnalysisFlag, {
  label: string;
  className: string;
}> = {
  follow: {
    label: 'Follow live',
    className: 'bg-surface text-fg-muted'
  },
  opportunity: {
    label: 'Improve',
    className: 'bg-ink-soft text-ink'
  },
  caution: {
    label: 'Redesign',
    className: 'bg-coral-soft text-rust'
  }
};

/** The 16-area audit: what the old design promised, what desktop actually does, and the call for mobile. */
export function DesignVsLiveTable() {
  return <div className="overflow-x-auto rounded-2xl border border-line bg-raised" data-id="element-185" data-mp="2o33j2zszo8dh">
      <table className="w-full min-w-[720px] text-left text-[13px]" data-id="element-186" data-mp="2t4swun7lj059">
        <thead data-id="element-187" data-mp="2y2lyr41v97zq">
          <tr className="border-b border-line text-xs text-fg-faint" data-id="element-188" data-mp="2y346awtzb8my">
            <th scope="col" className="px-4 py-3 font-medium" data-id="element-189" data-mp="ypqb90lo427m">Area</th>
            <th scope="col" className="px-4 py-3 font-medium" data-id="element-190" data-mp="yrkyilkew6ev">Old design</th>
            <th scope="col" className="px-4 py-3 font-medium" data-id="element-191" data-mp="13pmegxmjjpm4">Live desktop</th>
            <th scope="col" className="px-4 py-3 font-medium" data-id="element-192" data-mp="33xotmxi797c0">Call for mobile</th>
          </tr>
        </thead>
        <tbody data-id="element-193" data-mp="2z5nkvlk8pyqq">
          {designVsLiveRows.map(row => <tr key={row.area} className="border-b border-line align-top last:border-b-0" data-id="element-194" data-mp="2u7cejkt5m6d9">
              <th scope="row" className="px-4 py-3 font-semibold text-fg" data-id="element-195" data-mp="2q60ml8mt591w">{row.area}</th>
              <td className="px-4 py-3 text-fg-muted" data-id="element-196" data-mp="2q47dznsmwer9">{row.design}</td>
              <td className="px-4 py-3 text-fg-muted" data-id="element-197" data-mp="3mvrh37v3mw7p">{row.live}</td>
              <td className="px-4 py-3 text-fg" data-id="element-198" data-mp="3hwycy61pchk7">
                <span className={`mr-2 inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${FLAG[row.flag].className}`} data-id="element-199" data-mp="3hv3nqfjee3ab">
                  {FLAG[row.flag].label}
                </span>
                {row.mobile}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}